export default function (value, starter) {
  if (!value) return ''
  if (!value.startsWith(starter)) return ''
  return (value || '').replace(new RegExp(`^\\${starter}`), '')
}
